<template>
  <div>
    <div class="inst-title">솔리드 구조 검사</div>
    <pre class="inst-desc">생산을 위한 3D 모델의 기본적인 조건을 만족하지 않은 경우입니다.</pre>

    <div class="inst-subtitle">[해결방법]</div>

    <pre
      class="inst-desc"
    >· 3D캐드 Solid 모델링 설계 시 : 해당 검사가 실패하는 경우는 거의 없습니다.<br>· Surface 모델링 활용 시: Edge와 Vertex 등의 요소를 머지 하지 않아 모델이 정상적인 부피를 가지지 않는 경우 해당 검사가 실패합니다.</pre>
  </div>
</template>

<script setup></script>
